





























import { Component, Prop, Vue } from 'vue-property-decorator';
import { ListResult } from '@/services/api/nswag/stapiclient_generated';
import ListTable from '@/views/List/ListTable.vue';
import { stListApi } from '@/services/st-api';
import { AccountStore } from '@/store/account-module';

@Component({
  components: { ListTable },
})
export default class ListExport extends Vue {
  @Prop() listResultProp!: ListResult;
  listResult: ListResult = ListResult.fromJS({ rows: [] });
  guid: string = '';

  created() {
    this.guid = this.$route.params.guid;
  }

  async mounted() {
    if(!this.listResultProp){
      this.listResult = await stListApi.getListByGuid(this.guid);
    }else{
      this.listResult = this.listResultProp;
    }

  }

  get logoUrl() {
    return AccountStore.base64Logo;
  }
}
